import React from 'react'

const DockSelector = ({ docks, selectedDock, setSelectedDock, dockGroups }) => {

    const greyOutSmallTextStyle = {
        fontSize: '0.8rem',
        color: 'grey'
    }

    const handleGroupClick = (group) => {
        const liveDockIds = group.dockIds.filter(id => docks.some(d => d.id === id))
        setSelectedDock({ id: `group_${group.id}`, name: group.name, isGroup: true, dockIds: liveDockIds })
    }

    const isGroupActive = (group) => selectedDock?.id === `group_${group.id}`
    const isDockActive = (dock) => !selectedDock?.isGroup && dock.id === selectedDock?.id

    if (docks.length <= 1) {
        return null
    }

    const hasGroups = dockGroups && dockGroups.length > 0

    const groupedDockIds = hasGroups
        ? dockGroups.reduce((acc, g) => { g.dockIds.forEach(id => acc.add(id)); return acc }, new Set())
        : new Set()

    const individualDocks = hasGroups
        ? docks.filter(d => d.id === 99999999999999 || !groupedDockIds.has(d.id))
        : docks

    const getInboundOutbound = (dock) => {
        if (dock.inbound !== dock.outbound) {
            if (dock.inbound === 1) return 'Inbound'
            if (dock.outbound === 1) return 'Outbound'
        }
        return ''
    }

    const totalTabCount = (hasGroups ? dockGroups.length : 0) + individualDocks.length

    if (totalTabCount > 5) {
        const currentValue = selectedDock?.id != null ? String(selectedDock.id) : ''

        const handleChange = (e) => {
            const val = e.target.value
            if (val.startsWith('group_')) {
                const groupId = val.replace('group_', '')
                const group = dockGroups.find(g => String(g.id) === groupId)
                if (group) handleGroupClick(group)
            } else {
                const dock = docks.find(d => String(d.id) === val)
                if (dock) setSelectedDock(dock)
            }
        }

        const allDocksDock = docks.find(d => d.id === 99999999999999)

        return (
            <div className="mb-3" style={{ paddingTop: '6px' }} data-component="DockSelector">
                <div className="input-group input-group-sm" style={{ maxWidth: '300px' }}>
                    <select
                        className="form-select form-select-sm"
                        value={currentValue}
                        onChange={handleChange}
                        style={{ fontSize: '0.85rem' }}
                    >
                        {hasGroups && dockGroups.map(group => (
                            <option key={`group_${group.id}`} value={`group_${group.id}`}>
                                {group.name || 'Unnamed Group'}
                            </option>
                        ))}
                        {individualDocks.map(dock => {
                            const label = getInboundOutbound(dock)
                            return (
                                <option key={dock.id} value={String(dock.id)}>
                                    {dock.name}{label ? ` - ${label}` : ''}
                                </option>
                            )
                        })}
                    </select>
                    {allDocksDock && (
                        <button
                            className="btn btn-outline-secondary"
                            title="All Docks"
                            onClick={() => setSelectedDock(allDocksDock)}
                            style={{ borderColor: '#dee2e6', color: '#6c757d' }}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-layout-three-columns" viewBox="0 0 16 16">
                                <path d="M0 1.5A1.5 1.5 0 0 1 1.5 0h13A1.5 1.5 0 0 1 16 1.5v13a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 14.5zM1.5 1a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5H5V1zM10 15V1H6v14zm1 0h3.5a.5.5 0 0 0 .5-.5v-13a.5.5 0 0 0-.5-.5H11z"/>
                            </svg>
                        </button>
                    )}
                </div>
            </div>
        )
    }

    return (
        <div className="mb-3" data-component="DockSelector">
            <div className="d-flex flex-wrap">

                {hasGroups && dockGroups.map((group) => (
                    <span
                        key={group.id}
                        className={`flex-fill text-center pointerElement ${isGroupActive(group) ? 'fs-5 border-bottom border-primary' : ''}`}
                        onClick={() => handleGroupClick(group)}
                    >
                        {group.name || <em className="text-muted">Unnamed Group</em>}
                    </span>
                ))}

                {individualDocks.map((dock) => {
                    const inboundOrOutbound = getInboundOutbound(dock)
                    return (
                        <span
                            key={dock.id}
                            className={`flex-fill text-center pointerElement ${isDockActive(dock) ? 'fs-5 border-bottom border-primary' : ''}`}
                            onClick={() => setSelectedDock(dock)}
                        >
                            {dock.name}
                            {inboundOrOutbound ? (
                                <>
                                    <br />
                                    <span style={greyOutSmallTextStyle}>{inboundOrOutbound}</span>
                                </>
                            ) : null}
                        </span>
                    )
                })}
            </div>
        </div>
    )
}

export default DockSelector
